
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saatchi/collection",
      function () {
        return require("private-next-pages/saatchi/collection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saatchi/collection"])
      });
    }
  